import React, {
  useEffect,
  useState,
  useRef,
  useMemo,
  useCallback,
} from "react";
import {
  Accordion,
  AccordionBody,
  AccordionHeader,
  AccordionItem,
  Button,
  UncontrolledTooltip,
} from "reactstrap";
import { Notification, FullViewContainer, Icon } from "../common/style";
import { AccordionHeaderContainer } from "./style";
import { deleteItems } from "../product/service";
import {
  updateUserGroup,
  sortSectionItems,
  updateSection,
  updateOrderItemProperties,
  copyPasteOrderItem,
  copyPasteSection,
  loadGroup,
  loadModule,
  sortDirectItems,
  updateReviewStatus,
} from "./service";
import {
  removeProjectOverride,
  copyItemsV2,
  updateOrderItemData,
} from "../product/service";
import ConfirmationModal from "./ConfirmationModal";
import Cell from "./table/Cell";
import NameCell from "./table/cells/NameCell";
import ColorCell from "./table/cells/ColorCell";
import BoardCell from "./table/cells/BoardCell";
import HingeCell from "./table/cells/HingeCell";
import DrawerCell from "./table/cells/DrawerCell";
import HandleCell from "./table/cells/HandleCell";
import MechanismCell from "./table/cells/MechanismCell";
import BuildCell from "./table/cells/BuildCell";
import DimensionCell from "./table/cells/DimensionCell";
import FillerCell from "./table/cells/FillerCell";
import PriceCell from "./table/cells/PriceCell";
import ExtrasCell from "./table/cells/ExtrasCell";
import AddModuleDialog from "./table/AddModuleDialog";
import AddSectionModal from "./table/AddSectionModal";
import RightPanel from "./table/RightPanel";
import AddDirectModuleDialog from "./table/AddDirectModuleDialog";
import SectionTableHeader from "./table/SectionTableHeader";
import { isMobileOnly } from "react-device-detect";
import MobileBanner from "../common/MobileBanner";
import {
  DndContext,
  closestCenter,
  PointerSensor,
  useSensor,
  useSensors,
} from "@dnd-kit/core";
import {
  SortableContext,
  useSortable,
  verticalListSortingStrategy,
} from "@dnd-kit/sortable";
import {
  restrictToVerticalAxis,
  restrictToParentElement,
} from "@dnd-kit/modifiers";
import { CSS } from "@dnd-kit/utilities";
import ContextMenu from "./table/ContextMenu";

const SectionAccordion = ({
  isLoading,
  setIsLoading,
  currentRoom,
  projectSummary,
  selectionManager,
  projectId,
  loadRoom,
  access,
  refreshProjectSummary,
  mutateCurrentRoom,
  isAdmin,
  finalisedContexts,
  isorderfinalised,
  currentSelection,
  setCurrentSelection,
  setCurrentTab,
  setRoom,
  viewMode,
  isListProject,
  showRoomView = false,
  cameraView,
  setCameraView,
  wallView,
}) => {
  const showSpec = viewMode === "spec";
  const showRemarks = viewMode === "remarks";
  const showReview = viewMode === "review";
  const selectionManagerRef = useRef(selectionManager);
  const [isNotificationVisible, setIsNotificationVisible] = useState(true);
  const [notificationMessage, setNotificationMessage] = useState({});
  const [disableAddModuleCell, setDisableAddModuleCell] = useState(false);
  const [addedProductsWidth, setAddedProductsWidth] = useState(0);
  const [activeSectionId, setActiveSectionId] = useState(null);
  const [expandedSections, setExpandedSections] = useState([]);
  const [showAddSection, setShowAddSection] = useState(false);
  const [showAddDirectModules, setShowAddDirectModules] = useState(false);
  const [isRightPanelVisible, setIsRightPanelVisible] = useState(false);
  const [sectionDimensions, setSectionDimensions] = useState({
    height: {},
    width: {},
    depth: {},
  });
  const [moduleDimensions, setModuleDimensions] = useState({
    height: {},
    width: {},
    depth: {},
  });
  const [currentCell, setCurrentCell] = useState({
    id: null,
    type: null,
    column: null,
    status: null,
    errorMessage: null,
  });
  const [copyPasteTooltip, setCopyPasteTooltip] = useState({
    show: false,
    message: "",
    target: null,
  });
  const [copiedCell, setCopiedCell] = useState({
    id: null,
    type: null,
    column: null,
  });
  const [highlightedCell, setHighlightedCell] = useState({
    id: null,
    type: null,
    column: null,
  });
  const [openClearOverrideModal, setOpenClearOverrideModal] = useState(false);
  const [clearOverrideFunc, setClearOverrideFunc] = useState(false);
  const [orderItemNames, setOrderItemNames] = useState({});
  const [sectionNames, setSectionNames] = useState({});
  const [blurredItems, setBlurredItems] = useState({});
  const [editingCell, setEditingCell] = useState(null);
  const sensors = useSensors(
    useSensor(PointerSensor, {
      activationConstraint: {
        distance: 10,
      },
    })
  );
  const [blurLabel, setBlurLabel] = useState("");
  const [blurDirectModuleLabel, setBlurDirectModuleLabel] = useState([]);
  const [pasteOverrides, setPasteOverrides] = useState({});
  const [contextMenu, setContextMenu] = useState({
    visible: false,
    x: 0,
    y: 0,
    target: null, // 'cell' or 'row'
    item: null, // The item being right-clicked
    cellData: null, // Only for cell context
    forDirectModules: false, //copy for paste as direct module
  });
  const [showItemsDeleteConfirmation, setShowItemsDeleteConfirmation] =
    useState(false);
  const toggleShowItemsDeleteConfirmation = () =>
    setShowItemsDeleteConfirmation(!showItemsDeleteConfirmation);

  const colorIdentifiers = ["shutter_color", "internal_color"];
  const moduleColorIdentifiers = ["color", "internal_color"];
  const boardIdentifiers = ["shutter_material", "carcass_material"];

  const allReviewColumns = [
    "review_shutter_material",
    "review_carcass_material",
    "review_hinge",
    "review_drawer_mechanism_type",
    "review_handle_type",
    "review_sliding_mechanism",
    "review_front_edge_thickness",
    "review_partition_front_edge_thickness",
    "review_front_offset",
    "review_backsheet_build_technique",
    "review_minifix",
  ];

  const cameraViewMapper = {
    0: "front",
    90: "right",
    180: "back",
    270: "left",
  };

  const adjacentSidesMapper = {
    front: [0, 90, 270],
    right: [90, 0, 180],
    back: [180, 90, 270],
    left: [270, 0, 180],
    top: [0, 90, 180, 270],
  };

  const cellValuesRef = useRef({});
  const [colorMapVersion, setColorMapVersion] = useState(0);
  const updateTimeoutRef = useRef(null);

  // Generate color with darkness percentage (0-100)
  // darkness: 0 = white, 100 = full color
  const getColorWithDarkness = (baseColor, darkness) => {
    // Convert hex to RGB
    const hex = baseColor.replace("#", "");
    const r = parseInt(hex.substring(0, 2), 16);
    const g = parseInt(hex.substring(2, 4), 16);
    const b = parseInt(hex.substring(4, 6), 16);

    // Calculate darkness: interpolate between color and white
    // darkness 100 = full color, darkness 0 = white
    const factor = darkness / 100;
    const newR = Math.round(r * factor + 255 * (1 - factor));
    const newG = Math.round(g * factor + 255 * (1 - factor));
    const newB = Math.round(b * factor + 255 * (1 - factor));

    return `rgb(${newR}, ${newG}, ${newB})`;
  };

  const handleCellValueChange = useCallback((itemId, column, value) => {
    const key = `${itemId}__${column}`;
    // Normalize value: trim whitespace and handle empty strings consistently
    const normalizedValue = (value || "").trim();

    // Only update if value changed
    if (cellValuesRef.current[key] !== normalizedValue) {
      cellValuesRef.current[key] = normalizedValue;

      // Debounce color map recalculation to batch updates
      if (updateTimeoutRef.current) clearTimeout(updateTimeoutRef.current);

      updateTimeoutRef.current = setTimeout(() => {
        setColorMapVersion((prev) => prev + 1);
      }, 50);
    }
  }, []);

  // Helper function to create color map for a column
  const createColorMapForColumn = useCallback(
    (column, baseColor) => {
      const colorMap = {};
      const columnValueMap = new Map();

      // Collect values for this specific column
      Object.entries(cellValuesRef.current).forEach(([key, value]) => {
        const parts = key.split("__");
        if (parts.length < 2) return;

        const itemId = parts[0];
        const col = parts.slice(1).join("__");

        if (col === column) {
          const normalizedValue = (value || "").trim();

          if (!columnValueMap.has(normalizedValue)) {
            columnValueMap.set(normalizedValue, []);
          }
          columnValueMap.get(normalizedValue).push(itemId);
        }
      });

      // Separate empty values from non-empty values
      const emptyValue = "";
      const valueOccurrences = [];

      // Count occurrences for each value
      columnValueMap.forEach((itemIds, value) => {
        if (value !== "") {
          valueOccurrences.push({
            value: value,
            count: itemIds.length, // Number of items with this value
          });
        }
      });

      // Sort by occurrence count (ascending) - low occurrence first
      valueOccurrences.sort((a, b) => {
        if (a.count !== b.count) {
          return a.count - b.count; // Lower count first
        }
        // If same count, sort by value for consistency
        return a.value.localeCompare(b.value);
      });

      const uniqueCount = valueOccurrences.length;

      // Assign colors for empty values first
      if (columnValueMap.has(emptyValue)) {
        const mapKey = `${column}__${emptyValue}`;
        colorMap[mapKey] = "#f0f0f0"; // Light grey for empty values
      }

      // Assign colors for non-empty values
      if (uniqueCount === 1) {
        // Single unique value: use minimum darkness (20%)
        const mapKey = `${column}__${valueOccurrences[0].value}`;
        colorMap[mapKey] = getColorWithDarkness(baseColor, 20);
      } else if (uniqueCount > 1) {
        // Multiple unique values: distribute from 100% to 20%
        const stepSize = (100 - 20) / (uniqueCount - 1);
        valueOccurrences.forEach((item, index) => {
          const mapKey = `${column}__${item.value}`;
          // Calculate darkness: start at 100% for low occurrence, decrease for high occurrence
          // Minimum is 20%
          const darkness = Math.max(20, 100 - index * stepSize);
          colorMap[mapKey] = getColorWithDarkness(baseColor, darkness);
        });
      }

      return colorMap;
    },
    [getColorWithDarkness]
  );

  // Create color mapping from collected cell values (exact text match)
  const reviewColumnColorMap = useMemo(() => {
    const colorMap = {};
    const baseColors = ["#6698D1", "#66D172"];

    // Process each column separately to assign colors
    allReviewColumns.forEach((column) => {
      // Get the column's position in the original list to determine color
      const columnIndex = allReviewColumns.indexOf(column);
      const baseColor = baseColors[columnIndex % 2];
      const columnColorMap = createColorMapForColumn(column, baseColor);
      Object.assign(colorMap, columnColorMap);
    });

    return colorMap;
  }, [colorMapVersion, createColorMapForColumn]);

  // Create color maps for Dimension columns
  const dimensionColorMaps = useMemo(() => {
    if (!showReview) return {};

    const baseColors = ["#66D172", "#6698D1"];

    return {
      height: createColorMapForColumn("height", baseColors[0]),
      width: createColorMapForColumn("width", baseColors[1]),
      depth: createColorMapForColumn("depth", baseColors[0]),
    };
  }, [showReview, colorMapVersion, createColorMapForColumn]);

  // Expand all accordions when entering review mode
  useEffect(() => {
    if (showReview && currentRoom?.groups) {
      const allGroupIds = currentRoom.groups.map((group) => group.id);
      setExpandedSections(allGroupIds);
    } else if (!showReview) {
      setExpandedSections([]);
    }
  }, [showReview, currentRoom]);

  // Toggle accordion in review mode
  const handleAccordionToggle = useCallback(
    (groupId) => {
      setExpandedSections((prev) => {
        if (prev.includes(groupId)) return prev.filter((id) => id !== groupId);
        else return [...prev, groupId];
      });
    },
    [showReview]
  );

  const toggleClearOverrideModal = () =>
    setOpenClearOverrideModal(!openClearOverrideModal);

  const toggleAddSectionModal = () => setShowAddSection(!showAddSection);

  const onDismissNotification = () => {
    setIsNotificationVisible(false);
  };

  const showCopyPasteTooltip = (message, target) => {
    setCopyPasteTooltip({ show: true, message, target });
    setTimeout(() => {
      setCopyPasteTooltip({ show: false, message: "", target: null });
    }, 5000);
  };

  const canPaste = (targetType, item) => {
    try {
      if (targetType === "cell") {
        const cellClipboard = localStorage.getItem("copiedCellData");

        const pastingData =
          item.type == "group"
            ? tableManager.isCurrentlyFocused()
            : currentCell;
        if (!cellClipboard) return false;

        const { copy_data } = JSON.parse(cellClipboard);
        if (!copy_data || !pastingData) return false;

        return (
          copy_data.type === pastingData.type &&
          copy_data.column === pastingData?.column
        );
      } else {
        const rowClipboard = localStorage.getItem("copiedObjects");

        if (!rowClipboard) return false;

        const copy_data = JSON.parse(rowClipboard);
        if (!copy_data) return false;

        const hasModuleData = copy_data?.items?.[0]?.type === "module";
        const isTargetGroup = currentSelection?.[0]?.type === "group";

        return hasModuleData && isTargetGroup;
      }
    } catch {
      return false;
    }
  };

  const deleteSelectedItems = (items) => {
    selectionManager.removeItems(items);

    if (isListProject && items[0].type === "module" && items[0].is_packed)
      selectionManager.select(selectionManager.findGroup(items[0].group_id));

    deleteItems({
      projectId: projectId,
      roomId: currentRoom.id,
      items: items.map(({ type, id }) => ({
        type,
        id,
      })),
    })
      .then((room) => {
        setRoom(room);
        refreshProjectSummary();
      })
      .catch(({ error }) => {
        setIsNotificationVisible(true);
        setNotificationMessage({
          text: error,
          type: "danger",
        });
      });
  };

  const handleContextMenu = (
    e,
    target,
    item,
    itemOrCellInfo,
    forDirectModules = false
  ) => {
    e.preventDefault();
    e.stopPropagation();
    if (target == "row" && !forDirectModules) {
      selectionManager.select(item);
    }
    if (itemOrCellInfo) {
      tableManager.set(
        itemOrCellInfo.id,
        itemOrCellInfo.type,
        itemOrCellInfo.column,
        "focus"
      );
    }
    setContextMenu({
      visible: true,
      x: e.clientX,
      y: e.clientY,
      target,
      item,
      cellData: itemOrCellInfo ? itemOrCellInfo : null,
      forDirectModules: forDirectModules,
    });
  };

  const handleCloseContextMenu = () => {
    setContextMenu((prev) => ({ ...prev, visible: false }));
  };

  const handleContextMenuCopy = () => {
    if (contextMenu.target === "cell") {
      handleCopyCell();
    } else {
      handleCopy();
    }
    setContextMenu({ ...contextMenu, visible: false });
  };

  const handleContextMenuPaste = (forDirectModules = false) => {
    if (contextMenu.target === "cell") {
      handlePasteCell();
    } else if (forDirectModules) {
      handlePaste(forDirectModules);
    } else {
      handlePaste();
    }
    setContextMenu({ ...contextMenu, visible: false });
  };

  useEffect(() => {
    selectionManagerRef.current = selectionManager;

    // On load, open the active section accordion.
    if (selectionManager.activeGroupId()) {
      setActiveSectionId(selectionManager.activeGroupId());
    }
  }, [selectionManager]);

  useEffect(() => {
    window.addEventListener("keydown", handleKeyDown);

    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [currentCell]);

  useEffect(() => {
    const hasOtherSelection = selectionManager
      .selections()
      .some((s) => s.type !== "module" && s.type !== "group");

    if (hasOtherSelection) {
      setIsRightPanelVisible(true);
    } else {
      setIsRightPanelVisible(false);
    }
  }, [selectionManager.selections()]);

  useEffect(() => {
    const handleGlobalClick = () => {
      if (contextMenu.visible) {
        handleCloseContextMenu();
      }
    };

    window.addEventListener("click", handleGlobalClick);
    return () => {
      window.removeEventListener("click", handleGlobalClick);
    };
  }, [contextMenu.visible]);

  const canBlur = (groupId, dimension) => {
    return blurredItems[groupId] === dimension;
  };

  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      if (tableManager.isCurrentlyFocused()) {
        tableManager.set(
          currentCell.id,
          currentCell.type,
          currentCell.column,
          "active"
        );
      }
    }

    if (event.key === "Tab") {
      event.preventDefault();
      handleTabNavigation();
      return;
    }

    if (event.key === "Escape") {
      setShowAddDirectModules(false);
      setSectionNames({});
      setOrderItemNames({});
      setCurrentTab("info");
      setAddedProductsWidth(0);
      if (tableManager.isCurrentlyActive()) {
        tableManager.setStatus("focus");
      } else {
        if (tableManager.isCurrentlyFocused()) {
          tableManager.clear();
        }
      }
    }

    if (
      event.target instanceof HTMLInputElement ||
      event.target instanceof HTMLTextAreaElement
    )
      return;

    if (event.key === "c" && (event.ctrlKey || event.metaKey)) {
      if (tableManager.isCurrentlyFocused()) {
        handleCopyCell();
      } else {
        handleCopy();
      }
    }

    if (
      event.key === "v" &&
      (event.ctrlKey || event.metaKey) &&
      access.customize_module
    ) {
      if (tableManager.isCurrentlyFocused()) {
        handlePasteCell();
      } else {
        handlePaste();
      }
    }
  };

  const handleDuplicate = () => {
    handleCopy();
    handlePaste();
  };

  const handleCopy = (isCut = false) => {
    const selections = selectionManagerRef.current.selections();
    if (
      selections.length > 0 &&
      selections.every((selection) =>
        ["section", "module", "group"].includes(selection.type)
      )
    ) {
      localStorage.setItem(
        "copiedObjects",
        JSON.stringify({
          operation: isCut ? "cut" : "copy",
          items: selections.map(({ type, id }) => ({ type, id })),
        })
      );
    }
  };

  const handlePaste = (forDirectModules = false) => {
    const text = localStorage.getItem("copiedObjects");
    let clipboardSelections;
    try {
      clipboardSelections = JSON.parse(text);
    } catch (error) {
      return;
    }

    if (
      clipboardSelections &&
      clipboardSelections.items &&
      clipboardSelections.items.length > 0 &&
      ["cut", "copy"].includes(clipboardSelections.operation)
    ) {
      // TODO: Cut+Paste behaves like Copy+Paste for now.
      // setCanvasLoading(true);

      // COPY ITEMS
      setIsLoading(true);
      copyItemsV2({
        projectId: projectId,
        roomId: selectionManagerRef.current.currentRoom().id,
        items: clipboardSelections.items,
        target:
          selectionManagerRef.current.activeGroup() && !forDirectModules
            ? {
                type: selectionManagerRef.current.activeGroup().type,
                id: selectionManagerRef.current.activeGroup().id,
              }
            : null,
      })
        .then((response) => {
          // Setting position for groups
          response.copied_objects.forEach((item) => {
            if (item.type === "group") {
              item.position = selectionManager.calculateGroupPosition(
                (item.modules || []).concat(item.walls || [])
              );
            }
          });

          selectionManager.triggerLoadRoom(
            selectionManagerRef.current.currentRoom().id,
            null,
            response.copied_objects,
            true
          );
          refreshProjectSummary();
          selectionManager.select(response.copied_objects[0]);
        })
        .catch(({ error }) => {
          setIsNotificationVisible(true);
          setNotificationMessage({
            text: "Error Pasting items: " + error?.error,
            type: "danger",
          });
        })
        .finally(() => {
          // setCanvasLoading(false);
          setIsLoading(false);
          setTimeout(() => {
            localStorage.removeItem("copiedObjects");
            localStorage.removeItem("copiedCellData");
          }, 500);
        });
    }
  };

  const handleTabNavigation = () => {
    if (!currentCell) return;

    const { id, type, column } = currentCell;
    const columnOrder = [
      "name",
      "height",
      "width",
      "depth",
      "color",
      "board",
      "filler",
      "property",
      "price",
    ];
    const currentIndex = columnOrder.indexOf(column);

    if (currentIndex === -1) return;

    if (currentIndex < columnOrder.length - 1) {
      const nextColumn = columnOrder[currentIndex + 1];
      tableManager.set(id, type, nextColumn, "focus");
      return;
    }

    if (type === "section") {
      const group = selectionManager.findGroup(id);
      if (group.modules.length > 0) {
        tableManager.set(group.modules[0].id, "module", "name", "focus");
      } else {
        moveToNextSectionOrDirectModule(id);
      }
    } else {
      const module = selectionManager.findModule(id);
      if (module.group_id) {
        const group = selectionManager.findGroup(module.group_id);
        const moduleIndex = group.modules.findIndex((m) => m.id === id);

        if (moduleIndex < group.modules.length - 1) {
          tableManager.set(
            group.modules[moduleIndex + 1].id,
            "module",
            "name",
            "focus"
          );
        } else {
          moveToNextSectionOrDirectModule(group.id);
        }
      } else {
        const moduleIndex = currentRoom.modules.findIndex((m) => m.id === id);
        if (moduleIndex < currentRoom.modules.length - 1) {
          tableManager.set(
            currentRoom.modules[moduleIndex + 1].id,
            "module",
            "name",
            "focus"
          );
        } else {
          if (currentRoom.groups.length > 0) {
            tableManager.set(
              currentRoom.groups[0].id,
              "section",
              "name",
              "focus"
            );
          }
        }
      }
    }
  };

  const moveToNextSectionOrDirectModule = (currentGroupId) => {
    const groupIndex = currentRoom.groups.findIndex(
      (g) => g.id === currentGroupId
    );

    if (groupIndex < currentRoom.groups.length - 1) {
      const nextGroup = currentRoom.groups[groupIndex + 1];
      tableManager.set(nextGroup.id, "section", "name", "focus");
    } else if (currentRoom.modules.length > 0) {
      tableManager.set(currentRoom.modules[0].id, "module", "name", "focus");
    } else if (currentRoom.groups.length > 0) {
      tableManager.set(currentRoom.groups[0].id, "section", "name", "focus");
    }
  };

  const handleCopyCell = (isCut = false) => {
    if (!currentCell) return;
    localStorage.setItem(
      "copiedCellData",
      JSON.stringify({
        operation: isCut ? "cut" : "copy",
        copy_data: currentCell,
      })
    );
    tableManager.setCopiedCell(
      currentCell.id,
      currentCell.type,
      currentCell.column
    );
    setTimeout(() => {
      tableManager.clearCopiedCell();
    }, 1000);
  };

  const handlePasteCell = () => {
    const text = localStorage.getItem("copiedCellData");
    let clipboardCellData;
    try {
      clipboardCellData = JSON.parse(text);
    } catch (error) {
      console.error("Invalid clipboard data");
      return;
    }

    if (
      clipboardCellData &&
      clipboardCellData.copy_data &&
      ["cut", "copy"].includes(clipboardCellData.operation)
    ) {
      const { id, column, type } = currentCell;
      const sourceCell = clipboardCellData.copy_data;
      const targetCell = currentCell;

      if (sourceCell.type !== targetCell.type) {
        showCopyPasteTooltip(
          `Can only paste ${sourceCell.type} data to ${sourceCell.type}`,
          `cell_${targetCell.type}_${targetCell.id}_${targetCell.column}`
        );
        return;
      }
      if (sourceCell.column !== targetCell.column) {
        showCopyPasteTooltip(
          `Can only paste ${sourceCell.column} data to ${sourceCell.column}`,
          `cell_${targetCell.type}_${targetCell.id}_${targetCell.column}`
        );
        return;
      }
      const copiedItem =
        sourceCell.type === "module"
          ? selectionManager.findModule(sourceCell.id)
          : selectionManager.findGroup(sourceCell.id);

      if (copiedItem) {
        let pasteValue;
        if (["height", "width", "depth"].includes(sourceCell.column)) {
          pasteValue = copiedItem.dimensions[sourceCell.column];
        } else if (sourceCell.column === "name") {
          pasteValue = copiedItem.name;
        } else if (sourceCell.column === "color") {
          pasteValue = {
            shutter_color: copiedItem.selected_values?.shutter_color,
            color: copiedItem.selected_values?.color,
            internal_color: copiedItem.selected_values?.internal_color,
          };
        } else if (sourceCell.column === "board") {
          pasteValue = {
            shutter_material: copiedItem.selected_values?.shutter_material,
            carcass_material: copiedItem.selected_values?.carcass_material,
          };
        } else if (sourceCell.column === "property") {
          pasteValue = { selected_values: copiedItem.selected_values };
        } else if (
          sourceCell.column === "filler" &&
          sourceCell.type == "section"
        ) {
          pasteValue = { sides: copiedItem.sides };
        } else if (
          (sourceCell.column === "filler") &
          (sourceCell.type == "module")
        ) {
          pasteValue = {
            exposed_side_left: copiedItem.selected_values?.exposed_side_left,
            exposed_side_right: copiedItem.selected_values?.exposed_side_right,
            exposed_side_top: copiedItem.selected_values?.exposed_side_top,
            exposed_side_bottom:
              copiedItem.selected_values?.exposed_side_bottom,
            exposed_side_back: copiedItem.selected_values?.exposed_side_back,
            left_expo_color: copiedItem.selected_values?.left_expo_color,
            right_expo_color: copiedItem.selected_values?.right_expo_color,
            top_expo_color: copiedItem.selected_values?.top_expo_color,
            bottom_expo_color: copiedItem.selected_values?.bottom_expo_color,
            back_expo_color: copiedItem.selected_values?.back_expo_color,
          };
        } else {
          console.error("Unsupported column type for paste");
          return;
        }
        setPasteOverrides((prev) => ({
          ...prev,
          [`${id}-${type}-${column}`]: pasteValue,
        }));
      }
      if (sourceCell && targetCell) {
        const payload = {
          copy_id: sourceCell.id,
          column: sourceCell.column,
        };
        if (currentCell.type == "module") {
          tableManager.highlight(currentCell.id, "module", currentCell.column);

          copyPasteOrderItem({
            projectId,
            orderItemId: currentCell.id,
            ...payload,
          })
            .then((module) => {
              replaceModule(module);
              setBlurredItems((prev) => {
                const updated = { ...prev };
                delete updated[module.id];
                return updated;
              });
              setNotificationMessage({
                type: "success",
                message: "Copied successfully!",
              });
              setIsNotificationVisible(true);
            })
            .catch((error) => {
              setIsNotificationVisible(true);
              setNotificationMessage({
                text: "Error Pasting cell: " + error?.error,
                type: "danger",
              });
            })
            .finally(() => {
              tableManager.highlight(
                currentCell.id,
                "module",
                currentCell.column
              );

              setTimeout(() => {
                localStorage.removeItem("copiedObjects");
                localStorage.removeItem("copiedCellData");
              }, 500);
            });
        }
        if (currentCell.type == "section") {
          tableManager.highlight(currentCell.id, "section", currentCell.column);

          copyPasteSection({
            id: currentCell.id,
            ...payload,
          })
            .then((section) => {
              replaceGroup(section);
              setBlurredItems((prev) => {
                const updated = { ...prev };
                delete updated[section.id];
                return updated;
              });
            })
            .catch((error) => {
              setIsNotificationVisible(true);
              setNotificationMessage({
                text: "Error Pasting Cell: " + error?.error,
                type: "danger",
              });
            })
            .finally((_) =>
              tableManager.highlight(
                currentCell.id,
                "section",
                currentCell.column
              )
            );
        }
      }
      setTimeout(() => {
        setHighlightedCell(null);
      }, 2000);
    }
  };

  const handleUpdateSectionName = (groupId) => {
    const name = sectionNames[groupId];

    if (!name || name.trim().length === 0) return;

    selectionManager.findGroup(groupId).name = name;

    return updateSection({
      id: groupId,
      name: name,
    }).catch(({ error }) => {
      setIsNotificationVisible(true);
      setNotificationMessage({ type: "error", message: error });
    });
  };

  const updateLocalProject = ({
    entity = "room",
    entityId,
    entityName,
    parentId = null, // roomId for entity 'Group'
    action,
  }) => {
    if (entity === "group") {
      return updateLocalGroup({
        groupId: entityId,
        groupName: entityName,
        roomId: parentId,
        action,
      });
    }
  };

  const updateLocalGroup = ({ roomId, groupName, groupId, action }) => {
    // Mutating "project" -> To update the group names in module "Add To Room" CTA
    switch (action) {
      case "add": {
        currentRoom.groups.push({
          id: groupId,
          name: groupName,
          modules: [],
          position: { x: 0, y: 0 },
          dimensions: { height: 0, width: 0, depth: 0 },
          type: "group",
          category: "StackedGroup",
        });

        break;
      }
      case "update": {
        const groupIndex = currentRoom.groups.findIndex(
          (group) => group.id == groupId
        );

        currentRoom.groups[groupIndex].name = groupName;
        currentRoom.groups[groupIndex] = {
          ...currentRoom.groups[groupIndex],
          name: groupName,
        };

        break;
      }
      case "delete": {
        currentRoom.groups = currentRoom.groups.filter(
          (group) => group.id !== groupId
        );

        loadRoom(currentRoom.id);

        break;
      }
    }
  };

  const handleDimensionChange = (dimension, id, value, item) => {
    const setterFunc =
      item === "section" ? setSectionDimensions : setModuleDimensions;

    setterFunc((prev) => ({
      ...prev,
      [dimension]: {
        ...prev[dimension],
        [id]: value,
      },
    }));
  };

  const isDimensionNotValid = (dimension, value) => {
    if (value == null) return;

    if (parseInt(value) > 2400 && dimension !== "width") {
      return true;
    }

    return value.length > 0 && !/^\d*$/.test(value);
  };

  const isNameNotValid = (value) => value === "";

  const replaceGroup = (updatedGroup) => {
    const group =
      selectionManager.findGroup(updatedGroup.id) ||
      selectionManager.findGroupByTempId(updatedGroup.temp_id);

    delete updatedGroup.temp_id;
    delete group.temp_id;
    Object.assign(group, updatedGroup);
  };

  const replaceGroupForModuleChange = (
    updatedGroup,
    childId,
    dimensionKey,
    shouldUpdateFromServer
  ) => {
    const group = selectionManager.findGroup(updatedGroup.id);

    const newGroup = {
      ...updatedGroup,
      modules: updatedGroup.modules.map((m) => {
        if (m.id == childId) {
          replaceServerDataForModule(
            m,
            shouldUpdateFromServer ? dimensionKey : ""
          );

          return group.modules.find((module) => module.id == m.id);
        } else return m;
      }),
    };

    Object.assign(group, newGroup);
  };

  const replaceModule = (updatedModule) => {
    const module =
      selectionManager.findModule(updatedModule.id) ||
      selectionManager.findModuleByTempId(updatedModule.temp_id);

    delete updatedModule.temp_id;
    delete module.temp_id;
    Object.assign(module, updatedModule);
  };

  const replaceServerDataForModule = (updatedModule, dimensionKey) => {
    const module = selectionManager.findModule(updatedModule.id);

    if (!module) {
      console.warn("Module not found for id:", updatedModule.id);
      return;
    }

    // If dimensionKey is provided, merge dimensions carefully
    if (dimensionKey && updatedModule.dimensions) {
      const mergedModule = {
        ...updatedModule,
        dimensions: {
          ...module.dimensions,
          [dimensionKey]: updatedModule.dimensions[dimensionKey],
        },
      };
      replaceModule(mergedModule);
    } else {
      // Otherwise, pass the full updatedModule - replaceModule will merge it
      replaceModule(updatedModule);
    }
  };

  const updateSectionDimensions = ({ group, dimension, value }) => {
    if (
      typeof value != "string" ||
      value.trim().length === 0 ||
      isDimensionNotValid(dimension, value)
    ) {
      return;
    }

    if (dimension !== "width") {
      // For height and depth, copy the value to non-overriden modules.
      group.modules.forEach((module) => {
        if (!module.dimensions_overriden[dimension]) {
          module.dimensions[dimension] = parseInt(value);
        }
      });
    }

    setBlurredItems((prev) => ({
      ...prev,
      [group.id]: dimension,
    }));

    return updateSection({
      id: group.id,
      dimension: { [dimension]: value },
    })
      .then((section) => {
        replaceGroup(section);
        handleDimensionChange(dimension, group.id, null, "section");
        refreshProjectSummary();
        tableManager.clearError("section", group.id, dimension);
        tableManager.clearEditingCell();

        setBlurredItems((prev) => {
          const updated = { ...prev };
          delete updated[group.id];
          return updated;
        });
      })
      .catch(({ error }) => {
        setIsNotificationVisible(true);
        setNotificationMessage({ type: "error", message: error });
        tableManager.setErrorMessage(error, group.id, "section", dimension);
      });
  };

  const updateSectionProperties = ({
    id,
    propIdentifier,
    optionIdentifier,
  }) => {
    return updateSection({
      id,
      property: { [propIdentifier]: optionIdentifier },
    })
      .then((section) => {
        replaceGroup(section);
        refreshProjectSummary();
      })
      .catch(({ error }) => {
        setIsNotificationVisible(true);
        setNotificationMessage({ type: "error", message: error });
        tableManager.setErrorMessage(error, id, "section", "property");
      });
  };

  const updateSectionFillers = ({ id, sides }) => {
    setBlurredItems((prev) => ({
      ...prev,
      [id]: "width",
    }));
    return updateSection({ id, sides })
      .then((section) => {
        section.position = selectionManager.calculateGroupPosition(
          section.modules
        );
        replaceGroup(section);
        refreshProjectSummary();
        setBlurredItems((prev) => {
          const updated = { ...prev };
          delete updated[id];
          return updated;
        });
      })
      .catch(({ error }) => {
        setIsNotificationVisible(true);
        setNotificationMessage({ type: "error", message: error });
        tableManager.setErrorMessage(error, id, "section", "filler");
      });
  };

  const updateModuleDimensions = ({ orderItem, dimension }) => {
    let val = dimension?.value;
    if (
      typeof val !== "string" ||
      isDimensionNotValid(dimension.identifier, val)
    ) {
      return;
    }

    val = parseInt(val);

    setBlurredItems((prev) => ({
      ...prev,
      [orderItem.group_id]: dimension.identifier,
    }));

    let shouldUpdateFromServer = false;

    if (val) {
      orderItem.dimensions[dimension.identifier] = val;
      orderItem.dimensions_overriden[dimension.identifier] = true;
    } else {
      if (!orderItem.dimensions_overriden[dimension.identifier]) return;

      shouldUpdateFromServer = true;
    }

    return updateOrderItemProperties({
      projectId,
      orderItemIds: [orderItem.id],
      dimensions: { [dimension.identifier]: val },
    })
      .then((response) => {
        if (Array.isArray(response))
          response.forEach((item) => replaceServerDataForModule(item));
        else
          replaceGroupForModuleChange(
            response,
            orderItem.id,
            dimension.identifier,
            shouldUpdateFromServer
          );
        tableManager.clearEditingCell();
        clearModuleDimensionsForModule(orderItem.id);
        refreshProjectSummary();
        tableManager.clearError("module", orderItem.id, dimension.identifier);
        setBlurredItems((prev) => {
          const updated = { ...prev };
          delete updated[orderItem.group_id];
          return updated;
        });
      })
      .catch(({ error }) => {
        setIsNotificationVisible(true);
        setNotificationMessage({ type: "error", message: error });
        tableManager.setErrorMessage(
          error,
          orderItem.id,
          "module",
          dimension.identifier
        );
      });
  };

  const updateModuleProperties = ({ id, propIdentifier, optionIdentifier }) => {
    const orderItem = selectionManager.findModule(id);
    const property = orderItem?.property_list?.find(
      (prop) => prop.uniq_id === propIdentifier
    );
    const isShutterLevel = property?.is_shutter_level_color_property === true;

    return updateOrderItemProperties({
      projectId,
      orderItemIds: [id],
      properties: { [propIdentifier]: optionIdentifier },
      isShutterColor: isShutterLevel,
    })
      .then((response) => {
        if (Array.isArray(response)) {
          response.forEach((item) => {
            const currentModule = selectionManager.findModule(item.id);
            if (currentModule?.property_list) {
              item.property_list = item.property_list.map((serverProp) => {
                const localProp = currentModule.property_list.find(
                  (p) => p.uniq_id === serverProp.uniq_id
                );
                if (localProp) {
                  if (localProp.is_overridden_v2) {
                    serverProp.is_overridden_v2 = true;
                  }
                  if (localProp.is_shutter_override) {
                    serverProp.is_shutter_override = true;
                  }
                  if (localProp.is_shutter_level_color_property !== undefined) {
                    serverProp.is_shutter_level_color_property =
                      localProp.is_shutter_level_color_property;
                  }
                  if (localProp.options) {
                    serverProp.options = serverProp.options.map((serverOpt) => {
                      const localOpt = localProp.options.find(
                        (o) => o.identifier === serverOpt.identifier
                      );
                      if (localOpt?.selected) {
                        serverOpt.selected = true;
                      }
                      return serverOpt;
                    });
                  }
                }
                return serverProp;
              });
            }
            replaceServerDataForModule(item);
          });
        } else {
          replaceGroup(response);
        }

        refreshProjectSummary();
      })
      .catch(({ error }) => {
        setIsNotificationVisible(true);
        setNotificationMessage({ type: "error", message: error });
        tableManager.setErrorMessage(error, id, "module", "property");
      });
  };

  const clearModuleOverrides = ({ id, propIdentifier }) => {
    const orderItem = selectionManager.findModule(id);
    const property = orderItem?.property_list?.find(
      (prop) => prop.uniq_id === propIdentifier
    );
    const isShutterLevel = property?.is_shutter_level_color_property === true;

    const groupId =
      orderItem?.group_id ||
      currentRoom.groups.find((group) =>
        group.modules?.some((m) => m.id === id)
      )?.id;

    removeProjectOverride({
      projectId,
      groupId: groupId,
      orderItemIds: [id],
      propertyIdentifier: propIdentifier,
      isShutterColor: isShutterLevel,
    })
      .then((orderItems) => {
        orderItems.forEach((o) => replaceServerDataForModule(o));
        refreshProjectSummary();
      })
      .catch(({ error }) => {
        setIsNotificationVisible(true);
        setNotificationMessage({ type: "error", message: error });
      });
  };

  const clearPasteOverride = (id, type, column) => {
    setPasteOverrides((prev) => {
      const copy = { ...prev };
      delete copy[`${id}-${type}-${column}`];
      return copy;
    });
  };

  const handleUpdateOrderItemData = (orderItemId) => {
    const orderItemName = orderItemNames[orderItemId];

    if (!orderItemName || orderItemName.trim().length === 0) return;

    selectionManager.findModule(orderItemId).name = orderItemName;

    updateOrderItemData({
      projectId,
      groupId: selectionManager.activeGroupId(),
      orderItemId,
      orderItemName,
    })
      .then(() => {
        refreshProjectSummary?.();
        mutateCurrentRoom?.();
      })
      .catch(({ error }) => {
        setIsNotificationVisible(true);
        setNotificationMessage({ type: "error", message: error });
      });
  };

  const handleReviewedClick = (orderItem) => {
    const isReviewed = !orderItem.is_reviewed;

    updateReviewStatus({ projectId, id: orderItem.id, isReviewed })
      .then((response) => {
        if (response.success) {
          orderItem.is_reviewed = isReviewed;
          // Force re-render by updating currentRoom
          mutateCurrentRoom();
        }
      })
      .catch((error) => {
        setIsNotificationVisible(true);
        setNotificationMessage({
          type: "error",
          text: error.error || "Failed to mark item as reviewed",
        });
      });
  };

  const computeCameraView = (rotation) => {
    if (wallView === "1") {
      return cameraViewMapper[rotation];
    } else if (
      wallView === "3" &&
      !adjacentSidesMapper[cameraView].includes(rotation)
    ) {
      return cameraViewMapper[rotation];
    } else return cameraView;
  };

  const LineItem = (orderItem, dragHandleProps = {}) => {
    const moduleErrorFields = orderItem.module_errors
      ? Object.keys(orderItem.module_errors)
      : [];
    const selectedGroup = selectionManager.findGroup(orderItem.group_id);

    const isGroupSelected =
      orderItem.group_id && selectionManager.isSelected(selectedGroup);

    const isLineItemSelected = selectionManager.isSelected(orderItem);

    const isSiblingOfSelectedLineItem =
      selectionManager.selectedModule() && orderItem.group_id != null
        ? selectionManager.selectedModule().group_id == orderItem.group_id
        : false;

    const rotation = selectedGroup
      ? selectedGroup.rotation
      : orderItem.rotation;

    return (
      <>
        <div
          className={`d-flex border-bottom position-relative ${
            isGroupSelected
              ? "bg-fafafa"
              : isLineItemSelected && !showReview
              ? "bg-cyan"
              : isSiblingOfSelectedLineItem
              ? "bg-fafafa"
              : ""
          } ${orderItem.group_id == null && !showRoomView ? "border-top" : ""}`}
          style={{
            alignItems: "stretch",
          }}
          onContextMenu={(e) => {
            if (!selectionManager.isSelected(orderItem)) {
              selectionManager.select(orderItem);
              tableManager.clear();
            }
            e.preventDefault();
            const target = tableManager.isCurrentlyFocused() ? "cell" : "row";
            handleContextMenu(e, target, orderItem);
          }}
        >
          {showReview && (
            <div
              className="position-absolute top-0"
              style={{
                left: "50px",
                height: "100%",
                width: "-webkit-fill-available",
                zIndex: "99999",
              }}
            ></div>
          )}
          {showReview && (
            <div
              className="pointer border-end d-flex justify-content-center align-items-center review-check-column"
              style={{
                width: "60px",
                position: "sticky",
                left: 0,
                zIndex: 1010,
                backgroundColor: "white",
              }}
              onClick={() => handleReviewedClick(orderItem)}
            >
              <i
                className={`fa-solid fa-check-circle fs-5 review-check-icon ${
                  orderItem.is_reviewed ? "review-check-icon-reviewed" : ""
                }`}
              />
            </div>
          )}
          <div
            className="d-flex justify-content-center align-items-center border-end"
            onClick={() => {
              if (showReview) return;

              if (selectionManager.isSelected(orderItem)) {
                selectionManager.clear();
                tableManager.clear();
              } else {
                // Tell RoomCanvas to center on this selection via parent state
                if (typeof window !== "undefined") {
                  window.dispatchEvent(
                    new Event("roomcanvas:center-on-next-selection")
                  );
                }
                selectionManager.select(orderItem);

                if (cameraView !== "top")
                  setCameraView(computeCameraView(rotation));

                tableManager.clear();
              }

              return true;
            }}
            style={{
              minWidth: isMobileOnly ? "10%" : "35px",
              cursor: orderItem.is_packed ? "grab" : "pointer",
              backgroundColor:
                isLineItemSelected && !showReview
                  ? "#0d6efd"
                  : blurLabel === orderItem.group_id ||
                    blurDirectModuleLabel.includes(orderItem.id)
                  ? "#DDD"
                  : "transparent",
              color: isLineItemSelected && !showReview ? "white" : "",
            }}
            {...dragHandleProps}
          >
            <div className="d-flex align-items-center gap-1">
              {orderItem.group_id && (
                <i
                  className="fa-solid fa-arrow-right"
                  style={{ fontSize: "10px", color: "#999" }}
                ></i>
              )}
              <span>{orderItem.label}</span>

              {orderItem.module_errors &&
                Object.keys(orderItem.module_errors).length > 0 && (
                  <>
                    <i
                      className="fa-solid fa-circle-exclamation"
                      id={`module-error-icon-${orderItem.id}`}
                      style={{
                        color: "red",
                        fontSize: "12px",
                        cursor: "pointer",
                      }}
                    />
                    <UncontrolledTooltip
                      placement="left"
                      target={`module-error-icon-${orderItem.id}`}
                    >
                      {Object.entries(orderItem.module_errors)
                        .map(([field, messages]) => ` ${messages.join(", ")}`)
                        .join("\n")}
                    </UncontrolledTooltip>
                  </>
                )}
            </div>
          </div>
          <NameCell
            type="module"
            rowId={orderItem.id}
            column="name"
            name={orderItem.name}
            isFiller={orderItem.is_filler}
            tempId={orderItem.temp_id}
            sku={orderItem.sku}
            value={
              pasteOverrides[`${orderItem.id}-module-name`] ??
              orderItemNames[orderItem.id] ??
              orderItem.name ??
              ""
            }
            onChange={(e) => {
              setOrderItemNames((prev) => ({
                ...prev,
                [orderItem.id]: e.target.value,
              }));
              clearPasteOverride(orderItem.id, "module", "name");
            }}
            onFocus={() => {
              if (tableManager.isCurrentlyFocused()) {
                tableManager.set(orderItem.id, "module", "name", "active");
              }
            }}
            onBlur={() => {
              handleUpdateOrderItemData(orderItem.id);
              clearPasteOverride(orderItem.id, "module", "name");
            }}
            showRoomView={showRoomView}
            disabled={!access.customize_section || orderItem.is_filler}
            invalid={isNameNotValid(orderItemNames[orderItem.id])}
            tableManager={tableManager}
            errorMessage={tableManager.getError(orderItem.id, "module", "name")}
            sectionId={orderItem.group_id}
            pasteOverrides={pasteOverrides[`${orderItem.id}-module-name`]}
            handleTabNavigation={handleTabNavigation}
            onContextMenu={(e) => {
              handleContextMenu(e, "cell", orderItem, {
                id: orderItem.id,
                type: "module",
                column: "name",
              });
            }}
            className={showReview || showSpec ? "flex-grow-1" : ""}
            showRemarks={showRemarks}
            viewMode={viewMode}
            cameraView={cameraView}
            setCameraView={setCameraView}
          />
          {!showRoomView &&
            ((!showSpec && !showRemarks && isMobileOnly) || !isMobileOnly) &&
            ["height", "width", "depth"].map((dimension) => {
              const rawValue =
                pasteOverrides[`${orderItem.id}-module-${dimension}`] ??
                moduleDimensions[dimension][orderItem.id];
              const isOverriden = orderItem.dimensions_overriden?.[dimension];
              const placeholder =
                rawValue === "" ? "" : orderItem.dimensions[dimension];
              const inputId = `module_${dimension}_${orderItem.id}`;
              const fixedDimension =
                orderItem.dimensions_range &&
                orderItem.dimensions_range[`min_${dimension}`] ==
                  orderItem.dimensions_range[`max_${dimension}`];
              const hasError = (dimension) =>
                moduleErrorFields.includes(dimension);

              return (
                <>
                  <DimensionCell
                    key={`${orderItem.id}-${dimension}`}
                    type="module"
                    rowId={orderItem.id}
                    dimension={dimension}
                    tempId={orderItem.temp_id}
                    rawValue={rawValue}
                    placeholder={placeholder}
                    disabled={
                      !access.customize_section ||
                      orderItem.is_filler ||
                      fixedDimension
                    }
                    hasError={hasError(dimension)}
                    invalid={
                      isDimensionNotValid(dimension, rawValue) ||
                      (!orderItem.group_id && rawValue === "")
                    }
                    onFocus={() => {
                      if (
                        tableManager.isFocused(
                          "module",
                          orderItem.is,
                          dimension
                        )
                      ) {
                        tableManager.set(
                          orderItem.id,
                          "module",
                          dimension,
                          "active"
                        );
                      }
                      handleDimensionChange(
                        dimension,
                        orderItem.id,
                        orderItem.dimensions[dimension],
                        "module"
                      );
                    }}
                    onChange={(ev) => {
                      handleDimensionChange(
                        dimension,
                        orderItem.id,
                        ev.target.value,
                        "module"
                      );
                      clearPasteOverride(orderItem.id, "module", dimension);
                    }}
                    onBlur={() => {
                      if (rawValue === "") {
                        tableManager.setEditingCell(
                          orderItem.id,
                          "module",
                          dimension
                        );
                      }
                      updateModuleDimensions({
                        orderItem,
                        dimension: {
                          identifier: dimension,
                          value: rawValue,
                        },
                      });
                      clearPasteOverride(orderItem.id, "module", dimension);
                    }}
                    isFiller={orderItem.is_filler}
                    isOverriden={isOverriden}
                    errorMessage={tableManager.getError(
                      orderItem.id,
                      "module",
                      dimension
                    )}
                    sectionId={orderItem.group_id}
                    showClearOverrideTooltip={
                      orderItem.is_packed && isOverriden
                    }
                    blurred={tableManager.shouldBlurCell(
                      orderItem.id,
                      "module",
                      dimension,
                      orderItem.group_id,
                      isOverriden
                    )}
                    tableManager={tableManager}
                    inputId={inputId}
                    pasteOverrides={
                      pasteOverrides[`${orderItem.id}-module-${dimension}`]
                    }
                    handleTabNavigation={handleTabNavigation}
                    onContextMenu={(e) => {
                      handleContextMenu(e, "cell", orderItem, {
                        id: orderItem.id,
                        type: "module",
                        column: dimension,
                      });
                    }}
                    viewMode={viewMode}
                    dimensionColorMap={dimensionColorMaps[dimension]}
                    onValueChange={handleCellValueChange}
                  />
                  {!orderItem.is_filler && fixedDimension && (
                    <UncontrolledTooltip target={inputId} placement="top">{`${
                      dimension[0].toUpperCase() + dimension.slice(1)
                    } not editable for this module.`}</UncontrolledTooltip>
                  )}
                </>
              );
            })}
          {!showRoomView &&
            ((!showSpec && !showRemarks && isMobileOnly) || !isMobileOnly) && (
              <ColorCell
                type="module"
                rowId={orderItem.id}
                tempId={orderItem.temp_id}
                sectionId={orderItem.group_id}
                isFillerRow={orderItem.is_filler}
                errorMessage={tableManager.getError(
                  orderItem.id,
                  "module",
                  "color"
                )}
                tableManager={tableManager}
                propertyList={orderItem.property_list}
                colorIdentifiers={moduleColorIdentifiers}
                isActive={tableManager.isActive(
                  "module",
                  orderItem.id,
                  "color"
                )}
                dialogProps={{
                  orderItem,
                  access,
                  updateModuleProperties,
                  toggleClearOverrideModal,
                  setClearOverrideFunc,
                  clearModuleOverrides,
                  mutateCurrentRoom,
                  isAdmin,
                }}
                pasteOverrides={pasteOverrides[`${orderItem.id}-module-color`]}
                onContextMenu={(e) => {
                  handleContextMenu(e, "cell", orderItem, {
                    id: orderItem.id,
                    type: "module",
                    column: "color",
                  });
                }}
                setCurrentTab={setCurrentTab}
                viewMode={viewMode}
              />
            )}
          {!showRoomView && (showSpec || showReview) && (
            <BoardCell
              type="module"
              rowId={orderItem.id}
              tempId={orderItem.temp_id}
              sectionId={orderItem.group_id}
              isFiller={orderItem.is_filler}
              errorMessage={tableManager.getError(
                orderItem.id,
                "module",
                "board"
              )}
              tableManager={tableManager}
              propertyList={orderItem.property_list}
              boardIdentifiers={boardIdentifiers}
              dialogProps={{
                orderItem,
                access,
                tableManager,
                boardIdentifiers,
                updateModuleProperties,
                toggleClearOverrideModal,
                setClearOverrideFunc,
                clearModuleOverrides,
                mutateCurrentRoom,
                isAdmin,
              }}
              pasteOverrides={pasteOverrides[`${orderItem.id}-module-board`]}
              onContextMenu={(e) => {
                handleContextMenu(e, "cell", orderItem, {
                  id: orderItem.id,
                  type: "module",
                  column: "board",
                });
              }}
              setCurrentTab={setCurrentTab}
              viewMode={viewMode}
              reviewColumnColorMap={reviewColumnColorMap}
              onValueChange={handleCellValueChange}
            />
          )}
          {!showRoomView && (showSpec || showReview) && (
            <HandleCell
              type="module"
              rowId={orderItem.id}
              tempId={orderItem.temp_id}
              sectionId={orderItem.group_id}
              isFiller={orderItem.is_filler}
              errorMessage={tableManager.getError(
                orderItem.id,
                "module",
                "handle"
              )}
              tableManager={tableManager}
              propertyList={orderItem.property_list}
              onContextMenu={(e) => {
                handleContextMenu(e, "cell", orderItem, {
                  id: orderItem.id,
                  type: "module",
                  column: "handle",
                });
              }}
              dialogProps={{
                access,
                isAdmin,
                tableManager,
                orderItem,
                updateModuleProperties,
                toggleClearOverrideModal,
                setClearOverrideFunc,
                clearModuleOverrides,
                mutateCurrentRoom,
              }}
              viewMode={viewMode}
              reviewColumnColorMap={reviewColumnColorMap}
              onValueChange={handleCellValueChange}
            />
          )}
          {!showRoomView && (showSpec || showReview) && (
            <HingeCell
              type="module"
              rowId={orderItem.id}
              tempId={orderItem.temp_id}
              sectionId={orderItem.group_id}
              isFiller={orderItem.is_filler}
              errorMessage={tableManager.getError(
                orderItem.id,
                "module",
                "hinge"
              )}
              tableManager={tableManager}
              propertyList={orderItem.property_list}
              onContextMenu={(e) => {
                handleContextMenu(e, "cell", orderItem, {
                  id: orderItem.id,
                  type: "module",
                  column: "hinge",
                });
              }}
              dialogProps={{
                access,
                isAdmin,
                tableManager,
                orderItem,
                updateModuleProperties,
                toggleClearOverrideModal,
                setClearOverrideFunc,
                clearModuleOverrides,
                mutateCurrentRoom,
              }}
              viewMode={viewMode}
              reviewColumnColorMap={reviewColumnColorMap}
              onValueChange={handleCellValueChange}
              setCurrentTab={setCurrentTab}
            />
          )}
          {!showRoomView && (showSpec || showReview) && (
            <DrawerCell
              type="module"
              rowId={orderItem.id}
              tempId={orderItem.temp_id}
              sectionId={orderItem.group_id}
              isFiller={orderItem.is_filler}
              errorMessage={tableManager.getError(
                orderItem.id,
                "module",
                "drawer"
              )}
              tableManager={tableManager}
              propertyList={orderItem.property_list}
              onContextMenu={(e) => {
                handleContextMenu(e, "cell", orderItem, {
                  id: orderItem.id,
                  type: "module",
                  column: "drawer",
                });
              }}
              dialogProps={{
                access,
                isAdmin,
                tableManager,
                orderItem,
                updateModuleProperties,
                toggleClearOverrideModal,
                setClearOverrideFunc,
                clearModuleOverrides,
                mutateCurrentRoom,
              }}
              viewMode={viewMode}
              reviewColumnColorMap={reviewColumnColorMap}
              onValueChange={handleCellValueChange}
              setCurrentTab={setCurrentTab}
            />
          )}
          {!showRoomView && (showSpec || showReview) && (
            <MechanismCell
              type="module"
              rowId={orderItem.id}
              tempId={orderItem.temp_id}
              sectionId={orderItem.group_id}
              isFiller={orderItem.is_filler}
              errorMessage={tableManager.getError(
                orderItem.id,
                "module",
                "mechanism"
              )}
              tableManager={tableManager}
              propertyList={orderItem.property_list}
              onContextMenu={(e) => {
                handleContextMenu(e, "cell", orderItem, {
                  id: orderItem.id,
                  type: "module",
                  column: "mechanism",
                });
              }}
              dialogProps={{
                access,
                isAdmin,
                tableManager,
                orderItem,
                updateModuleProperties,
                toggleClearOverrideModal,
                setClearOverrideFunc,
                clearModuleOverrides,
                mutateCurrentRoom,
              }}
              viewMode={viewMode}
              reviewColumnColorMap={reviewColumnColorMap}
              onValueChange={handleCellValueChange}
            />
          )}
          {!showRoomView && (showSpec || showReview) && (
            <BuildCell
              type="module"
              rowId={orderItem.id}
              tempId={orderItem.temp_id}
              sectionId={orderItem.group_id}
              isFiller={orderItem.is_filler}
              errorMessage={tableManager.getError(
                orderItem.id,
                "module",
                "build"
              )}
              tableManager={tableManager}
              propertyList={orderItem.property_list}
              onContextMenu={(e) => {
                handleContextMenu(e, "cell", orderItem, {
                  id: orderItem.id,
                  type: "module",
                  column: "build",
                });
              }}
              dialogProps={{
                access,
                isAdmin,
                tableManager,
                orderItem,
                updateModuleProperties,
                toggleClearOverrideModal,
                setClearOverrideFunc,
                clearModuleOverrides,
                mutateCurrentRoom,
              }}
              viewMode={viewMode}
              reviewColumnColorMap={reviewColumnColorMap}
              onValueChange={handleCellValueChange}
            />
          )}
          {!showRoomView && (showSpec || showReview) && (
            <ExtrasCell
              type="module"
              rowId={orderItem.id}
              remarks={orderItem.remarks}
              attachments={orderItem.attachments}
              orderItem={orderItem}
              tableManager={tableManager}
              sectionId={orderItem.group_id}
              isFiller={orderItem.is_filler}
              projectId={projectId}
              groupId={orderItem.group_id}
              mutateCurrentRoom={mutateCurrentRoom}
              replaceModule={replaceModule}
              refreshProjectSummary={refreshProjectSummary}
              viewMode={viewMode}
            />
          )}
          {!showRoomView && !isMobileOnly && (
            <FillerCell
              type="module"
              rowId={orderItem.id}
              sectionId={orderItem.group_id}
              tempId={orderItem.temp_id}
              isFiller={orderItem.is_filler}
              propertyList={orderItem.property_list}
              tableManager={tableManager}
              errorMessage={tableManager.getError(
                orderItem.id,
                "module",
                "filler"
              )}
              dialogProps={{
                orderItem,
                tableManager,
                updateModuleProperties,
                mutateCurrentRoom,
              }}
              pasteOverrides={pasteOverrides[`${orderItem.id}-module-filler`]}
              onContextMenu={(e) => {
                handleContextMenu(e, "cell", orderItem, {
                  id: orderItem.id,
                  type: "module",
                  column: "filler",
                });
              }}
              viewMode={viewMode}
            />
          )}

          {!showRoomView && (showSpec || showReview) && (
            <PriceCell
              type="module"
              rowId={orderItem.id}
              tempId={orderItem.temp_id}
              price={orderItem.price}
              sectionId={orderItem.group_id}
              isFiller={orderItem.is_filler}
              errorMessage={tableManager.getError(
                orderItem.id,
                "module",
                "price"
              )}
              tableManager={tableManager}
              dialogProps={{
                orderItem,
                tableManager,
              }}
              price_per_sqft={orderItem.price_per_sqft}
              viewMode={viewMode}
              access={access}
            />
          )}
        </div>
        {!showRoomView &&
          contextMenu.visible &&
          contextMenu.item?.id === orderItem.id && (
            <ContextMenu
              x={contextMenu.x}
              y={contextMenu.y}
              onClose={handleCloseContextMenu}
              onCopy={handleContextMenuCopy}
              onPaste={handleContextMenuPaste}
              onDuplicate={handleDuplicate}
              onDelete={() => {
                setShowItemsDeleteConfirmation(true);
              }}
              disablePaste={!canPaste(contextMenu.target, orderItem)}
              id={orderItem.id}
              target={contextMenu.target}
              item={contextMenu.item}
              cellData={contextMenu.cellData}
              isFillerProduct={orderItem.is_filler}
            />
          )}
      </>
    );
  };

  const blurOverlayStyle = {
    position: "absolute",
    left: 0,
    top: 0,
    width: "60%",
    height: "100%",
    backgroundColor: "rgba(0,0,0,0.5)",
    pointerEvents: "auto",
    zIndex: 999,
  };

  const groupIdForModule = (moduleId) => {
    const group = currentRoom.groups.find((group) =>
      group.modules.some((module) => module.id === moduleId)
    );
    return group ? group.id : null;
  };

  const clearSectionDimensionsForGroup = (groupId) => {
    let tempSection = sectionDimensions;
    delete tempSection.depth[groupId];
    delete tempSection.height[groupId];
    delete tempSection.width[groupId];
    setSectionDimensions(tempSection);
  };

  const clearModuleDimensionsForModule = (moduleId) => {
    let tempModule = moduleDimensions;
    delete tempModule.depth[moduleId];
    delete tempModule.height[moduleId];
    delete tempModule.width[moduleId];
    setModuleDimensions(tempModule);
  };

  const tableManager = {
    highlight: (id, type, column) => {
      setHighlightedCell(null);

      requestAnimationFrame(() => {
        setHighlightedCell({ id, type, column });
      });
    },
    set: (id, type, column, status) => {
      setCurrentCell({
        id,
        type,
        column,
        status,
      });

      if (type === "section") {
        const section = selectionManager.findGroup(id);

        if (section) {
          selectionManager.select(section);

          if (cameraView !== "top")
            setCameraView(computeCameraView(section.rotation));
        }

        setActiveSectionId(id);
      } else if (type === "module") {
        const module = selectionManager.findModule(id);

        if (module) {
          selectionManager.select(module);

          if (cameraView !== "top") {
            const group =
              module.group_id && selectionManager.findGroup(module.group_id);

            const rotation = group ? group.rotation : module.rotation;

            setCameraView(computeCameraView(rotation));
          }
        }
      }
    },
    setStatus: (status) => {
      setCurrentCell({ ...currentCell, status: status });
    },
    setErrorMessage: (errorMessage, rowId, rowType, column) => {
      if (rowType === "section") {
        const group = currentRoom.groups.find((g) => g.id === rowId);
        if (group) {
          group.errorMessage = group.errorMessage || {};
          group.errorMessage[column] = errorMessage;
        }
      } else if (rowType === "module") {
        for (const group of currentRoom.groups) {
          const module = group.modules.find((m) => m.id === rowId);
          if (module) {
            module.errorMessage = module.errorMessage || {};
            module.errorMessage[column] = errorMessage;
            break;
          }
        }
      }
      mutateCurrentRoom && mutateCurrentRoom();
    },
    getError: (rowId, rowType, column) => {
      if (rowType === "section") {
        const group = currentRoom.groups.find((g) => g.id === rowId);
        if (group) {
          return group.errorMessage ? group.errorMessage[column] : null;
        }
      } else if (rowType === "module") {
        for (const group of currentRoom.groups) {
          const module = group.modules.find((m) => m.id === rowId);
          if (module) {
            return module.errorMessage ? module.errorMessage[column] : null;
          }
        }
      }
      return null;
    },
    clearError: (rowType, rowId, column) => {
      if (rowType === "section") {
        const group = currentRoom.groups.find((g) => g.id === rowId);
        if (group && group.errorMessage) {
          delete group.errorMessage[column];
        }
      } else if (rowType === "module") {
        for (const group of currentRoom.groups) {
          const module = group.modules.find((m) => m.id === rowId);
          if (module && module.errorMessage) {
            delete module.errorMessage[column];
            break;
          }
        }
      }
      mutateCurrentRoom && mutateCurrentRoom();
    },
    reloadItem: (rowType, rowId, column) => {
      if (rowType === "section") {
        loadGroup({ projectId, roomId: currentRoom.id, groupId: rowId })
          .then((group) => {
            replaceGroup(group);
            tableManager.clearError(rowType, rowId, column);
            clearSectionDimensionsForGroup(group.id);
          })
          .catch((error) => {
            console.error("Failed to load group", error);
          });
      } else if (rowType === "module") {
        loadModule({
          projectId,
          roomId: currentRoom.id,
          groupId: groupIdForModule(rowId),
          moduleId: rowId,
        })
          .then((module) => {
            replaceModule(module);
            tableManager.clearError(rowType, rowId, column);
            clearModuleDimensionsForModule(module.id);
          })
          .catch((error) => {
            console.error("Failed to load module", error);
          });
      }
    },
    isActive: (rowType, rowId, column) => {
      return (
        currentCell &&
        currentCell.type === rowType &&
        currentCell.id === rowId &&
        currentCell.column === column &&
        currentCell.status === "active"
      );
    },
    isFocused: (rowType, rowId, column) => {
      return (
        currentCell &&
        currentCell.type === rowType &&
        currentCell.id === rowId &&
        currentCell.column === column &&
        currentCell.status === "focus"
      );
    },
    isHighlighted: (rowType, rowId, column) => {
      return (
        highlightedCell &&
        highlightedCell.type === rowType &&
        highlightedCell.id === rowId &&
        highlightedCell.column === column
      );
    },
    isCurrentlyActive: () => {
      return currentCell && currentCell.status === "active";
    },
    isCurrentlyFocused: () => {
      return currentCell && currentCell.status === "focus";
    },
    getStatus: (rowType, rowId, column) => {
      if (
        currentCell &&
        currentCell.type === rowType &&
        currentCell.id === rowId &&
        currentCell.column === column
      ) {
        return currentCell.status;
      } else {
        return "idle";
      }
    },
    isCleared: () => {
      return currentCell === null;
    },
    clear: () => {
      setCurrentCell(null);
    },
    setEditingCell: (rowId, rowType, column) => {
      setEditingCell({ rowId, rowType, column });
    },

    clearEditingCell: () => {
      setEditingCell(null);
    },

    isEditingCell: (rowId, rowType, column) => {
      return (
        editingCell &&
        editingCell.rowId === rowId &&
        editingCell.rowType === rowType &&
        editingCell.column === column
      );
    },
    shouldBlurCell: (
      rowId,
      rowType,
      dimension,
      groupId = null,
      isOverriden = false
    ) => {
      const isEditing = tableManager.isEditingCell(rowId, rowType, dimension);

      if (rowType === "section") {
        return isEditing;
      }

      if (rowType === "module") {
        return (
          isEditing ||
          ((dimension === "width" ||
            tableManager.isEditingCell(groupId, "section", dimension)) &&
            canBlur(groupId, dimension) &&
            !isOverriden)
        );
      }

      return false;
    },
    setCopiedCell: (rowId, rowType, column) => {
      setCopiedCell({ rowId, rowType, column });
    },
    clearCopiedCell: () => {
      setCopiedCell(null);
    },
    isCopiedCell: (rowId, rowType, column) => {
      return (
        copiedCell &&
        copiedCell.rowId === rowId &&
        copiedCell.rowType === rowType &&
        copiedCell.column === column
      );
    },
  };

  const handleDragEnd = (event) => {
    const { active, over } = event;

    if (active.id === over.id) return;

    let sortPosition = 1;
    const group = selectionManager.findGroup(
      selectionManager.findModule(active.id).group_id
    );
    const to = over.data.current.sortable.index + 1;

    setBlurLabel(group.id);

    group.modules
      .filter((m) => !m.is_filler)
      .sort((a, b) => a.sort_position - b.sort_position)
      .forEach((m) => {
        if (m.id == active.id) {
          m.sort_position = to;
          return;
        }

        m.sort_position = to > sortPosition ? sortPosition : sortPosition + 1;
        sortPosition++;
      });

    mutateCurrentRoom();

    sortSectionItems({
      projectId,
      groupId: group.id,
      payload: {
        order_item_id: active.id,
        to: over.data.current.sortable.index + 1,
      },
    }).then((section) => {
      replaceGroup(section);
      mutateCurrentRoom();
      setBlurLabel("");
    });
  };

  const handleDirectModuleDragEnd = (event) => {
    const { active, over } = event;

    if (active.id === over.id) return;

    const module = selectionManager.findModule(active.id);
    const modules = currentRoom.modules.filter((m) => !m.is_filler);

    const fromIndex = modules.findIndex((m) => m.id === active.id);
    const toIndex = over.data.current.sortable.index;

    const reordered = [...modules];
    const [moved] = reordered.splice(fromIndex, 1);
    reordered.splice(toIndex, 0, moved);

    reordered.forEach((m, index) => {
      m.room_sort_order = index + 1;
    });
    const moduleIds = currentRoom.modules.map((module) => module.id);
    setBlurDirectModuleLabel(moduleIds);

    mutateCurrentRoom();

    sortDirectItems({
      projectId,
      roomId: currentRoom.id,
      payload: {
        order_item_id: active.id,
        to: toIndex + 1,
      },
    })
      .then((response) => {
        return loadRoom(response.id);
      })
      .then(() => {
        setBlurDirectModuleLabel([]);
      });
  };

  return (
    <>
      {notificationMessage.text && (
        <Notification
          color={notificationMessage.type}
          isOpen={isNotificationVisible}
          toggle={onDismissNotification}
        >
          {notificationMessage.text}
        </Notification>
      )}
      {isMobileOnly && <MobileBanner />}
      {currentRoom && projectSummary && (
        <FullViewContainer
          className={`new-project-summary ${isLoading ? "blurred" : ""}`}
          style={{ position: "relative" }}
        >
          <>
            <div
              style={{
                overflowX: showReview ? "auto" : "",
                width: showRoomView ? "fit-content" : "100%",
              }}
            >
              <div
                style={{
                  minWidth: showRoomView ? "auto" : "max-content",
                  position: "relative",
                  width: showRoomView ? "fit-content" : "auto",
                }}
              >
                <SectionTableHeader
                  viewMode={viewMode}
                  showRoomView={showRoomView}
                />
                <Accordion className="border-bottom">
                  {currentRoom.groups
                    .filter((group) => {
                      return true;
                    })
                    .map((group, index) => (
                      <div key={index}>
                        <Accordion
                          open={
                            showReview
                              ? expandedSections.includes(group.id)
                                ? group.id
                                : null
                              : activeSectionId
                          }
                          toggle={() => {
                            if (showReview) handleAccordionToggle(group.id);
                          }}
                          key={group.id}
                        >
                          <AccordionItem className="border-0">
                            <AccordionHeaderContainer className="m-0 p-0">
                              <AccordionHeader
                                targetId={group.id}
                                onContextMenu={(e) => {
                                  e.preventDefault();
                                  selectionManager.select(group);
                                  tableManager.clear();
                                  const target =
                                    tableManager.isCurrentlyFocused()
                                      ? "cell"
                                      : "row";
                                  handleContextMenu(e, target, group);
                                }}
                              >
                                {showReview && (
                                  <div
                                    className="border-end border-bottom"
                                    style={{
                                      width: "60px",
                                      position: "sticky",
                                      left: 0,
                                      zIndex: 1010,
                                      backgroundColor: "#EEEEEE",
                                    }}
                                  />
                                )}
                                <div
                                  className={`d-flex flex-grow-1 border-top position-relative ${
                                    showReview
                                      ? "bg-EEEEEE"
                                      : selectionManager.isSelected(group)
                                      ? "bg-cyan-blue"
                                      : "bg-EEEEEE"
                                  }`}
                                >
                                  {showReview && (
                                    <div
                                      className="position-absolute top-0"
                                      style={{
                                        left: "35px",
                                        height: "100%",
                                        width: "-webkit-fill-available",
                                        zIndex: "99999",
                                        cursor: "default",
                                      }}
                                      onClick={(e) => e.stopPropagation()}
                                    ></div>
                                  )}
                                  <div
                                    className="d-flex justify-content-center align-items-center border-end flex-grow-0 flex-shrink-0"
                                    onClick={
                                      showReview
                                        ? undefined
                                        : () => {
                                            if (
                                              selectionManager.isSelected(group)
                                            ) {
                                              setActiveSectionId(null);
                                              selectionManager.clear();
                                              tableManager.clear();
                                            } else {
                                              // Tell RoomCanvas to center on this selection
                                              if (typeof window !== "undefined") {
                                                window.dispatchEvent(
                                                  new Event(
                                                    "roomcanvas:center-on-next-selection"
                                                  )
                                                );
                                              }
                                              setActiveSectionId(group.id);
                                              selectionManager.select(group);
                                              if (cameraView !== "top")
                                                setCameraView(
                                                  computeCameraView(
                                                    group.rotation
                                                  )
                                                );
                                            }

                                            return true;
                                          }
                                    }
                                    style={{
                                      width: isMobileOnly ? "10%" : "35px",
                                      backgroundColor: showReview
                                        ? ""
                                        : selectionManager.isSelected(group)
                                        ? "#0d6efd"
                                        : "",
                                      color: showReview
                                        ? ""
                                        : selectionManager.isSelected(group)
                                        ? "white"
                                        : "",
                                      cursor: showReview
                                        ? "default"
                                        : "pointer",
                                    }}
                                  >
                                    {(!showReview &&
                                      (selectionManager.isSelected(group) ||
                                        group.modules.some(
                                          (o) =>
                                            o.id ===
                                            selectionManager.activeModuleId()
                                        ))) ||
                                    (showReview &&
                                      expandedSections.includes(group.id)) ? (
                                      <i className="fa-solid fa-chevron-down" />
                                    ) : (
                                      <i className="fa-solid fa-chevron-right" />
                                    )}
                                  </div>
                                  {group.category === "Section" ? (
                                    <>
                                      <NameCell
                                        type="section"
                                        rowId={group.id}
                                        column="name"
                                        name={group.name}
                                        tempId={group.temp_id}
                                        value={
                                          pasteOverrides[
                                            `${group.id}-section-name`
                                          ] ??
                                          sectionNames[group.id] ??
                                          group.name ??
                                          ""
                                        }
                                        onChange={(e) => {
                                          setSectionNames((prev) => ({
                                            ...prev,
                                            [group.id]: e.target.value,
                                          }));
                                          clearPasteOverride(
                                            group.id,
                                            "section",
                                            "name"
                                          );
                                        }}
                                        onFocus={() => {
                                          if (
                                            tableManager.isCurrentlyFocused()
                                          ) {
                                            tableManager.set(
                                              group.id,
                                              "section",
                                              "name",
                                              "active"
                                            );
                                          }
                                        }}
                                        onBlur={() => {
                                          handleUpdateSectionName(group.id);
                                          clearPasteOverride(
                                            group.id,
                                            "section",
                                            "name"
                                          );
                                        }}
                                        disabled={
                                          !access.customize_section ||
                                          group.temp_id
                                        }
                                        invalid={isNameNotValid(
                                          sectionNames[group.id]
                                        )}
                                        tableManager={tableManager}
                                        errorMessage={tableManager.getError(
                                          group.id,
                                          "section",
                                          "name"
                                        )}
                                        copyPasteTooltip={copyPasteTooltip}
                                        pasteOverrides={
                                          pasteOverrides[
                                            `${group.id}-section-name`
                                          ]
                                        }
                                        handleTabNavigation={
                                          handleTabNavigation
                                        }
                                        onContextMenu={(e) => {
                                          handleContextMenu(e, "cell", group, {
                                            id: group.id,
                                            type: "section",
                                            column: "name",
                                          });
                                        }}
                                        className={
                                          showReview || showSpec
                                            ? "flex-grow-1"
                                            : ""
                                        }
                                        showRoomView={showRoomView}
                                        showRemarks={showRemarks}
                                        viewMode={viewMode}
                                      />
                                      {!showRoomView &&
                                        ((!showSpec &&
                                          !showRemarks &&
                                          isMobileOnly) ||
                                          !isMobileOnly) &&
                                        ["height", "width", "depth"].map(
                                          (dimension) => {
                                            const isWidth =
                                              dimension === "width";
                                            const inputId = `section_${dimension}_${group.id}`;
                                            const rawValue =
                                              pasteOverrides[
                                                `${group.id}-section-${dimension}`
                                              ] ??
                                              sectionDimensions?.[dimension]?.[
                                                group.id
                                              ] ??
                                              group?.dimensions?.[dimension] ??
                                              "";

                                            return (
                                              <React.Fragment
                                                key={`${group.id}-${dimension}`}
                                              >
                                                <DimensionCell
                                                  type="section"
                                                  rowId={group.id}
                                                  sectionId={group.id}
                                                  dimension={dimension}
                                                  tempId={group.temp_id}
                                                  rawValue={rawValue}
                                                  placeholder={rawValue}
                                                  isOverriden={false}
                                                  isFiller={false}
                                                  disabled={
                                                    !access.customize_section ||
                                                    group.temp_id
                                                  }
                                                  onFocus={() => {
                                                    if (
                                                      tableManager.isFocused(
                                                        "section",
                                                        group.id,
                                                        dimension
                                                      )
                                                    ) {
                                                      tableManager.set(
                                                        group.id,
                                                        "section",
                                                        dimension,
                                                        "active"
                                                      );
                                                    }
                                                  }}
                                                  onChange={(ev) => {
                                                    tableManager.setEditingCell(
                                                      group.id,
                                                      "section",
                                                      dimension
                                                    );
                                                    handleDimensionChange(
                                                      dimension,
                                                      group.id,
                                                      ev.target.value,
                                                      "section"
                                                    );
                                                    clearPasteOverride(
                                                      group.id,
                                                      "section",
                                                      dimension
                                                    );
                                                  }}
                                                  onBlur={() => {
                                                    updateSectionDimensions({
                                                      group,
                                                      dimension,
                                                      value: rawValue,
                                                    });
                                                    clearPasteOverride(
                                                      group.id,
                                                      "section",
                                                      dimension
                                                    );
                                                  }}
                                                  errorMessage={tableManager.getError(
                                                    group.id,
                                                    "section",
                                                    dimension
                                                  )}
                                                  blurred={false}
                                                  showClearOverrideTooltip={
                                                    false
                                                  }
                                                  tableManager={tableManager}
                                                  inputId={inputId}
                                                  invalid={
                                                    isDimensionNotValid(
                                                      dimension,
                                                      rawValue
                                                    ) || rawValue === ""
                                                  }
                                                  inputStyle={{
                                                    color:
                                                      isWidth &&
                                                      group.remaining_width > 3
                                                        ? "#FF0000"
                                                        : undefined,
                                                    cursor:
                                                      isWidth &&
                                                      group.remaining_width >
                                                        3 &&
                                                      !tableManager.isActive(
                                                        "section",
                                                        group.id,
                                                        dimension
                                                      )
                                                        ? "help"
                                                        : undefined,
                                                  }}
                                                  pasteOverrides={
                                                    pasteOverrides[
                                                      `${group.id}-section-${dimension}`
                                                    ]
                                                  }
                                                  handleTabNavigation={
                                                    handleTabNavigation
                                                  }
                                                  onContextMenu={(e) => {
                                                    handleContextMenu(
                                                      e,
                                                      "cell",
                                                      group,
                                                      {
                                                        id: group.id,
                                                        type: "section",
                                                        column: dimension,
                                                      }
                                                    );
                                                  }}
                                                  viewMode={viewMode}
                                                  dimensionColorMap={
                                                    dimensionColorMaps[
                                                      dimension
                                                    ]
                                                  }
                                                  onValueChange={
                                                    handleCellValueChange
                                                  }
                                                />
                                                {isWidth && (
                                                  <UncontrolledTooltip
                                                    target={inputId}
                                                    placement="top"
                                                  >
                                                    {group.remaining_width > 3
                                                      ? `${group.remaining_width}mm space available in this section`
                                                      : "Section width fully packed by modules"}
                                                  </UncontrolledTooltip>
                                                )}
                                              </React.Fragment>
                                            );
                                          }
                                        )}
                                      {!showRoomView &&
                                        ((!showSpec &&
                                          !showRemarks &&
                                          isMobileOnly) ||
                                          !isMobileOnly) && (
                                          <ColorCell
                                            type="section"
                                            rowId={group.id}
                                            tempId={group.temp_id}
                                            isFillerRow={false}
                                            sectionId={null}
                                            errorMessage={tableManager.getError(
                                              group.id,
                                              "section",
                                              "color"
                                            )}
                                            tableManager={tableManager}
                                            propertyList={group.property_list}
                                            colorIdentifiers={colorIdentifiers}
                                            isActive={tableManager.isActive(
                                              "section",
                                              group.id,
                                              "color"
                                            )}
                                            dialogProps={{
                                              group,
                                              updateSectionProperties,
                                              mutateCurrentRoom,
                                              isAdmin,
                                            }}
                                            pasteOverrides={
                                              pasteOverrides[
                                                `${group.id}-section-color`
                                              ]
                                            }
                                            onContextMenu={(e) => {
                                              handleContextMenu(
                                                e,
                                                "cell",
                                                group,
                                                {
                                                  id: group.id,
                                                  type: "section",
                                                  column: "color",
                                                }
                                              );
                                            }}
                                            setCurrentTab={setCurrentTab}
                                            viewMode={viewMode}
                                          />
                                        )}
                                      {!showRoomView &&
                                        (showSpec || showReview) && (
                                          <BoardCell
                                            type="section"
                                            rowId={group.id}
                                            tempId={group.temp_id}
                                            isFiller={false}
                                            sectionId={group.id}
                                            errorMessage={tableManager.getError(
                                              group.id,
                                              "section",
                                              "board"
                                            )}
                                            tableManager={tableManager}
                                            propertyList={group.property_list}
                                            boardIdentifiers={boardIdentifiers}
                                            dialogProps={{
                                              group,
                                              tableManager,
                                              boardIdentifiers,
                                              updateSectionProperties,
                                              mutateCurrentRoom,
                                              isAdmin,
                                            }}
                                            pasteOverrides={
                                              pasteOverrides[
                                                `${group.id}-section-board`
                                              ]
                                            }
                                            onContextMenu={(e) => {
                                              handleContextMenu(
                                                e,
                                                "cell",
                                                group,
                                                {
                                                  id: group.id,
                                                  type: "section",
                                                  column: "board",
                                                }
                                              );
                                            }}
                                            setCurrentTab={setCurrentTab}
                                            viewMode={viewMode}
                                            onValueChange={
                                              handleCellValueChange
                                            }
                                          />
                                        )}
                                      {!showRoomView &&
                                        (showSpec || showReview) && (
                                          <HandleCell
                                            type="section"
                                            rowId={group.id}
                                            tempId={group.temp_id}
                                            isFiller={false}
                                            sectionId={group.id}
                                            errorMessage={tableManager.getError(
                                              group.id,
                                              "section",
                                              "handle"
                                            )}
                                            tableManager={tableManager}
                                            propertyList={group.property_list}
                                            onContextMenu={(e) => {
                                              handleContextMenu(
                                                e,
                                                "cell",
                                                group,
                                                {
                                                  id: group.id,
                                                  type: "section",
                                                  column: "handle",
                                                }
                                              );
                                            }}
                                            dialogProps={{
                                              group,
                                              tableManager,
                                              boardIdentifiers,
                                              updateSectionProperties,
                                              mutateCurrentRoom,
                                              isAdmin,
                                            }}
                                            viewMode={viewMode}
                                            reviewColumnColorMap={
                                              reviewColumnColorMap
                                            }
                                            onValueChange={
                                              handleCellValueChange
                                            }
                                          />
                                        )}
                                      {!showRoomView &&
                                        (showSpec || showReview) && (
                                          <HingeCell
                                            type="section"
                                            rowId={group.id}
                                            tempId={group.temp_id}
                                            isFiller={false}
                                            sectionId={group.id}
                                            errorMessage={tableManager.getError(
                                              group.id,
                                              "section",
                                              "hinge"
                                            )}
                                            tableManager={tableManager}
                                            propertyList={group.property_list}
                                            onContextMenu={(e) => {
                                              handleContextMenu(
                                                e,
                                                "cell",
                                                group,
                                                {
                                                  id: group.id,
                                                  type: "section",
                                                  column: "hinge",
                                                }
                                              );
                                            }}
                                            dialogProps={{
                                              group,
                                              tableManager,
                                              boardIdentifiers,
                                              updateSectionProperties,
                                              mutateCurrentRoom,
                                              isAdmin,
                                            }}
                                            viewMode={viewMode}
                                            reviewColumnColorMap={
                                              reviewColumnColorMap
                                            }
                                            onValueChange={
                                              handleCellValueChange
                                            }
                                            setCurrentTab={setCurrentTab}
                                          />
                                        )}
                                      {!showRoomView &&
                                        (showSpec || showReview) && (
                                          <DrawerCell
                                            type="section"
                                            rowId={group.id}
                                            tempId={group.temp_id}
                                            isFiller={false}
                                            sectionId={group.id}
                                            errorMessage={tableManager.getError(
                                              group.id,
                                              "section",
                                              "drawer"
                                            )}
                                            tableManager={tableManager}
                                            propertyList={group.property_list}
                                            onContextMenu={(e) => {
                                              handleContextMenu(
                                                e,
                                                "cell",
                                                group,
                                                {
                                                  id: group.id,
                                                  type: "section",
                                                  column: "drawer",
                                                }
                                              );
                                            }}
                                            dialogProps={{
                                              group,
                                              tableManager,
                                              boardIdentifiers,
                                              updateSectionProperties,
                                              mutateCurrentRoom,
                                              isAdmin,
                                            }}
                                            viewMode={viewMode}
                                            reviewColumnColorMap={
                                              reviewColumnColorMap
                                            }
                                            onValueChange={
                                              handleCellValueChange
                                            }
                                            setCurrentTab={setCurrentTab}
                                          />
                                        )}
                                      {!showRoomView &&
                                        (showSpec || showReview) && (
                                          <MechanismCell
                                            type="section"
                                            rowId={group.id}
                                            tempId={group.temp_id}
                                            isFiller={false}
                                            sectionId={group.id}
                                            errorMessage={tableManager.getError(
                                              group.id,
                                              "section",
                                              "mechanism"
                                            )}
                                            tableManager={tableManager}
                                            propertyList={group.property_list}
                                            onContextMenu={(e) => {
                                              handleContextMenu(
                                                e,
                                                "cell",
                                                group,
                                                {
                                                  id: group.id,
                                                  type: "section",
                                                  column: "mechanism",
                                                }
                                              );
                                            }}
                                            viewMode={viewMode}
                                            reviewColumnColorMap={
                                              reviewColumnColorMap
                                            }
                                            onValueChange={
                                              handleCellValueChange
                                            }
                                          />
                                        )}
                                      {!showRoomView &&
                                        (showSpec || showReview) && (
                                          <BuildCell
                                            type="section"
                                            rowId={group.id}
                                            tempId={group.temp_id}
                                            isFiller={false}
                                            sectionId={group.id}
                                            errorMessage={tableManager.getError(
                                              group.id,
                                              "section",
                                              "build"
                                            )}
                                            tableManager={tableManager}
                                            propertyList={group.property_list}
                                            onContextMenu={(e) => {
                                              handleContextMenu(
                                                e,
                                                "cell",
                                                group,
                                                {
                                                  id: group.id,
                                                  type: "section",
                                                  column: "build",
                                                }
                                              );
                                            }}
                                            viewMode={viewMode}
                                            reviewColumnColorMap={
                                              reviewColumnColorMap
                                            }
                                            onValueChange={
                                              handleCellValueChange
                                            }
                                          />
                                        )}
                                      {!showRoomView &&
                                        (showSpec || showReview) && (
                                          <ExtrasCell
                                            type="section"
                                            rowId={group.id}
                                            remarks={group.remarks}
                                            attachments={group.attachments}
                                            orderItem={group}
                                            tableManager={tableManager}
                                            sectionId={group.id}
                                            isFiller={false}
                                            projectId={projectId}
                                            groupId={group.id}
                                            mutateCurrentRoom={
                                              mutateCurrentRoom
                                            }
                                            replaceModule={replaceModule}
                                            refreshProjectSummary={
                                              refreshProjectSummary
                                            }
                                            viewMode={viewMode}
                                          />
                                        )}
                                      {!showRoomView && !isMobileOnly && (
                                        <FillerCell
                                          type="section"
                                          rowId={group.id}
                                          sectionId={group.id}
                                          tempId={group.temp_id}
                                          isFiller={false}
                                          sides={group.sides}
                                          tableManager={tableManager}
                                          selectionManager={selectionManager}
                                          errorMessage={tableManager.getError(
                                            group.id,
                                            "section",
                                            "filler"
                                          )}
                                          dialogProps={{
                                            group,
                                            tableManager,
                                            updateSectionFillers,
                                            mutateCurrentRoom,
                                            access,
                                            isAdmin,
                                          }}
                                          pasteOverrides={
                                            pasteOverrides[
                                              `${group.id}-section-filler`
                                            ]
                                          }
                                          onContextMenu={(e) => {
                                            handleContextMenu(
                                              e,
                                              "cell",
                                              group,
                                              {
                                                id: group.id,
                                                type: "section",
                                                column: "filler",
                                              }
                                            );
                                          }}
                                          viewMode={viewMode}
                                        />
                                      )}
                                    </>
                                  ) : (
                                    <Cell
                                      groupId={group.id}
                                      type="section"
                                      column="name"
                                      status="focus"
                                      className={
                                        showReview
                                          ? "flex-grow-1"
                                          : "flex-grow-0 flex-shrink-0"
                                      }
                                      customStyles={
                                        showReview
                                          ? {}
                                          : {
                                              width: isMobileOnly
                                                ? "130px"
                                                : "150px",
                                            }
                                      }
                                      tableManager={tableManager}
                                      errorMessage={tableManager.getError(
                                        group.id,
                                        "section",
                                        "name"
                                      )}
                                    >
                                      <p className="fw-bold mb-0">
                                        {group.name}
                                      </p>
                                    </Cell>
                                  )}
                                  {!showRoomView &&
                                    (showSpec || showReview) && (
                                      <PriceCell
                                        type="section"
                                        rowId={group.id}
                                        tempId={group.temp_id}
                                        price={group.price}
                                        sectionId={group.id}
                                        errorMessage={tableManager.getError(
                                          group.id,
                                          "section",
                                          "price"
                                        )}
                                        tableManager={tableManager}
                                        price_per_sqft={group.price_per_sqft}
                                        access={access}
                                      />
                                    )}
                                </div>
                              </AccordionHeader>
                              {!showRoomView &&
                                contextMenu.visible &&
                                contextMenu.item?.id === group.id && (
                                  <ContextMenu
                                    x={contextMenu.x}
                                    y={contextMenu.y}
                                    onClose={handleCloseContextMenu}
                                    onCopy={handleContextMenuCopy}
                                    onPaste={handleContextMenuPaste}
                                    onDuplicate={handleDuplicate}
                                    onDelete={() => {
                                      setShowItemsDeleteConfirmation(true);
                                    }}
                                    disablePaste={
                                      !canPaste(contextMenu.target, group)
                                    }
                                    id={`section-${group.id}`}
                                    target={contextMenu.target}
                                    item={contextMenu.item}
                                    cellData={contextMenu.cellData}
                                  />
                                )}
                            </AccordionHeaderContainer>

                            {!group.temp_id &&
                              (showReview ||
                                selectionManager.selectedModule()?.group_id ==
                                  group.id ||
                                selectionManager.isSelected(group)) && (
                                <AccordionBody accordionId={group.id}>
                                  {group.modules.length === 0 && (
                                    <div className="border-bottom p-4 text-secondary text-center bg-light-grey">
                                      No modules added to this section
                                    </div>
                                  )}
                                  <div>
                                    <DndContext
                                      sensors={sensors}
                                      collisionDetection={closestCenter}
                                      onDragEnd={handleDragEnd}
                                      modifiers={[
                                        restrictToVerticalAxis,
                                        restrictToParentElement,
                                      ]}
                                    >
                                      <SortableContext
                                        items={group.modules.map((m) => m.id)}
                                        strategy={verticalListSortingStrategy}
                                      >
                                        {group.modules
                                          .filter((m) => !m.is_filler)
                                          .sort(
                                            (a, b) =>
                                              a.sort_position - b.sort_position
                                          )
                                          .map((orderItem) => (
                                            <SortableLineItem
                                              key={orderItem.id}
                                              orderItem={orderItem}
                                              LineItem={LineItem}
                                            />
                                          ))}
                                      </SortableContext>
                                    </DndContext>
                                  </div>
                                  {group.modules
                                    .filter((m) => m.is_filler)
                                    .sort((a, b) => a.label - b.label)
                                    .map((orderItem) => LineItem(orderItem))}
                                  {group.category == "Section" &&
                                    access.customize_section &&
                                    !isMobileOnly &&
                                    !showReview &&
                                    !showRoomView && (
                                      <div className="d-flex position-relative">
                                        <Cell
                                          rowType="module"
                                          rowId="new"
                                          column="add_module"
                                          status="focus"
                                          className="ps-4 flex-grow-0 flex-shrink-0"
                                          customStyles={{ width: "185px" }}
                                          tableManager={tableManager}
                                          noBorder={true}
                                          disableAddModuleCell={
                                            disableAddModuleCell
                                          }
                                          errorMessage={tableManager.getError(
                                            "new",
                                            "module",
                                            "add_module"
                                          )}
                                        >
                                          <div className="link pointer py-2 ps-4">
                                            <Icon
                                              className="fa-solid fa-plus me-2"
                                              size="12px"
                                            />
                                            Add modules
                                          </div>
                                        </Cell>
                                        {tableManager.isActive(
                                          "module",
                                          "new",
                                          "add_module"
                                        ) && (
                                          <AddModuleDialog
                                            group={group}
                                            close={tableManager.clear}
                                            replaceGroup={replaceGroup}
                                            refreshProjectSummary={
                                              refreshProjectSummary
                                            }
                                            currentRoom={currentRoom}
                                            addedProductsWidth={
                                              addedProductsWidth
                                            }
                                            setAddedProductsWidth={
                                              setAddedProductsWidth
                                            }
                                            setDisableAddModuleCell={
                                              setDisableAddModuleCell
                                            }
                                            tableManager={tableManager}
                                            setRoom={setRoom}
                                            blurredItems={blurredItems}
                                            setBlurredItems={setBlurredItems}
                                          />
                                        )}
                                      </div>
                                    )}
                                </AccordionBody>
                              )}
                          </AccordionItem>
                        </Accordion>
                      </div>
                    ))}
                  <div>
                    <DndContext
                      sensors={sensors}
                      collisionDetection={closestCenter}
                      onDragEnd={handleDirectModuleDragEnd}
                      modifiers={[
                        restrictToVerticalAxis,
                        restrictToParentElement,
                      ]}
                    >
                      <SortableContext
                        items={currentRoom.modules.map((m) => m.id)}
                        strategy={verticalListSortingStrategy}
                      >
                        {currentRoom.modules
                          .sort((a, b) => a.room_sort_order - b.room_sort_order)
                          .map((orderItem) => (
                            <SortableLineItem
                              key={orderItem.id}
                              orderItem={orderItem}
                              LineItem={LineItem}
                            />
                          ))}
                      </SortableContext>
                    </DndContext>
                  </div>
                </Accordion>
              </div>
            </div>

            {!showReview && (
              <div
                onContextMenu={(e) => {
                  e.preventDefault();
                  tableManager.clear();
                  handleContextMenu(e, "row", null, null, true);
                }}
                style={{ height: "200px" }}
                className="pt-4"
              >
                <div className="d-flex justify-content-center">
                  {!showRoomView && !isMobileOnly && (
                    <Button
                      onClick={toggleAddSectionModal}
                      disabled={!access.customize_section}
                      className="bg-white text-primary border-primary rounded-1 btn btn-primary"
                    >
                      Add Section
                    </Button>
                  )}
                  {!showRoomView && (
                    <Button
                      onClick={setShowAddDirectModules}
                      disabled={!access.customize_section}
                      className="ms-2 bg-white text-primary border-primary rounded-1 btn btn-primary"
                    >
                      Add Modules
                    </Button>
                  )}
                </div>
                {!showRoomView &&
                  contextMenu.visible &&
                  contextMenu.forDirectModules && (
                    <ContextMenu
                      x={contextMenu.x}
                      y={contextMenu.y}
                      onClose={handleCloseContextMenu}
                      onCopy={handleContextMenuCopy}
                      onPaste={() =>
                        handleContextMenuPaste(contextMenu.forDirectModules)
                      }
                      onDuplicate={handleDuplicate}
                      onDelete={() => {
                        setShowItemsDeleteConfirmation(true);
                      }}
                      target={contextMenu.target}
                      item={contextMenu.item}
                      cellData={contextMenu.cellData}
                      forDirectModules={contextMenu.forDirectModules}
                    />
                  )}
              </div>
            )}

            {isRightPanelVisible && !isMobileOnly && (
              <div style={blurOverlayStyle} />
            )}

            {!isMobileOnly && (
              <RightPanel
                isVisible={isRightPanelVisible}
                onClose={() => setIsRightPanelVisible(false)}
                selectionManager={selectionManager}
                access={access}
                finalisedContexts={finalisedContexts}
                isOrderFinalised={isorderfinalised}
                currentSelection={currentSelection}
                setCurrentSelection={setCurrentSelection}
                setIsLoading={setIsLoading}
                deleteSelectedItems={deleteSelectedItems}
                currentRoom={currentRoom}
                projectId={projectId}
                loadRoom={loadRoom}
                refreshProjectSummary={refreshProjectSummary}
              />
            )}
          </>
        </FullViewContainer>
      )}

      <ConfirmationModal
        isOpen={openClearOverrideModal}
        toggle={toggleClearOverrideModal}
        onConfirm={clearOverrideFunc}
        message="Are you sure you want to remove the property?"
        headingText="Remove Property"
      />
      <ConfirmationModal
        isOpen={showItemsDeleteConfirmation}
        toggle={toggleShowItemsDeleteConfirmation}
        onConfirm={() => deleteSelectedItems(selectionManager.selections())}
        message={`Are you sure you want to delete ${
          selectionManager.selections().length
        } item${selectionManager.selections().length > 1 ? "s" : ""}`}
        headingText="Delete Items"
      />
      {showAddSection && (
        <AddSectionModal
          shouldShow={showAddSection}
          close={() => setShowAddSection(false)}
          toggle={toggleAddSectionModal}
          projectId={projectId}
          currentRoom={currentRoom}
          refreshProjectSummary={refreshProjectSummary}
          setNotificationMessage={setNotificationMessage}
          setIsNotificationVisible={setIsNotificationVisible}
          mutateCurrentRoom={mutateCurrentRoom}
        />
      )}

      {showAddDirectModules && (
        <AddDirectModuleDialog
          refreshProjectSummary={refreshProjectSummary}
          currentRoom={currentRoom}
          setShowAddDirectModules={setShowAddDirectModules}
          projectId={projectId}
          mutateCurrentRoom={mutateCurrentRoom}
          replaceModule={replaceModule}
        />
      )}
    </>
  );
};

const SortableLineItem = ({ orderItem, LineItem }) => {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({ id: orderItem.id });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    background: isDragging ? "#ccc" : "transparent",
    userSelect: "none",
  };

  return (
    <div ref={setNodeRef} style={style}>
      {LineItem(orderItem, { ...attributes, ...listeners })}
    </div>
  );
};

export default SectionAccordion;
